<template>
  <div class="fullheight">
    <eco-table
        @load="loadData"
        :data="data"
        :pageResult="pageResult"
        :selection="true"
        :default-querys="[{property:'o.ID_',value:this.orgId}]"
        quick-search-props="name"
        ref="ecoTable"
        :show-custom-column="false"
        :show-export="false">
      <template v-slot:toolbar>
        <el-button-group>
          <el-button size="small" @click="showDialog()" type="primary">添加岗位</el-button>
          <fe-delete-button
              :url="demDeleteUrl"
              :htTable="$refs.ecoTable"
              pk="code"
              class="marginRight16"
              parameter="postCodes"
              @after-delete="afterDelete"
          >删除</fe-delete-button>
        </el-button-group>
      </template>
      <template>
        <eco-table-column type="index" width="50" align="center" label="序号" />
        <eco-table-column
            prop="name"
            label="岗位名称"
            width="300"
            :sortable="true"
            :show-overflow-tooltip="true"
        >
          <template v-slot="{row,column,$index}">
            <el-link type="primary"  @click="handleCommand({row:row,command:'edit'})" title="点击编辑" >{{row.name}}</el-link>
          </template>
        </eco-table-column>
        <eco-table-column prop="code" label="岗位编码" :show-overflow-tooltip="true" />
        <eco-table-column prop="jobName" label="职务名称"  />
        <eco-table-column
            prop="isCharge"
            label="是否责任岗位"
            width="120"
            :filters="[{text:'否', value:'0'},{text:'是', value:'1'}]"
        >
          <template v-slot="{row}">
            <el-tag type="danger" v-if="row.isCharge=='0'">否</el-tag>
            <el-tag type="success" v-if="row.isCharge=='1'">是</el-tag>
          </template>
        </eco-table-column>
        <eco-table-column width="150">
          <template v-slot:header>
            <span>操作</span>
          </template>
          <template v-slot="{row}">
            <el-dropdown
                size="mini"
                @command="handleCommand"
            >
            <el-link type="primary" :underline="false">分配人员<i class="el-icon-arrow-down el-icon--right"></i></el-link>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="{row:row,command:'showInfo'}">分配人员</el-dropdown-item>
                <el-dropdown-item :command="{row:row,command:'orgInfo'}">岗位详情</el-dropdown-item>
                <el-dropdown-item :command="{row:row,command:'setPostMaster'}" v-if="row.isCharge">取消责任岗位</el-dropdown-item>
                <el-dropdown-item :command="{row:row,command:'setPostMaster'}" v-else>设置责任岗位</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </eco-table-column>
      </template>
    </eco-table>

    <eco-sidebar-dialog
        width="28%"
        title="添加岗位"
        :visible="dialogVisible"
        destroy-on-close
        :before-close="handleClose"
        :append-to-body="true"
    >
      <el-form v-model="OrgPost" data-vv-scope="editForm"  :label-position="position" style="padding: 20px">
        <eco-form-item label="职务名称" prop="name" label-width="100px" v-if="!readOnly">
          <eco-select
              v-model="OrgPost.jobCode"
              class="m-r"
              :options="job"
              :props="{key:'groupCode',value:'name'}"
              :validate="{required:true}"
          />
        </eco-form-item>
        <eco-form-item label="岗位名称" prop="code" label-width="100px">
          <eco-input
              v-model="OrgPost.name"
              autocomplete="off"
              :validate="{required:true}"
              placeholder="岗位名称"
          ></eco-input>
        </eco-form-item>
        <eco-form-item label="岗位编码" prop="code" label-width="100px">
          <eco-input
              v-model="OrgPost.code"
              autocomplete="off"
              v-pinyin="OrgPost.name"
              :validate="{required:true,alpha_num:true}"
              placeholder="岗位编码"
              :disabled="readOnly"
          ></eco-input>
        </eco-form-item>

      </el-form>
      <div class="demo-drawer__footer">
        <el-button @click="handleClose()">{{$t('eip.common.cancel')}}</el-button>
        <fe-submit-button
            :url="saveOrgPost"
            :model="OrgPost"
            :isSubmit="isSubmit"
            :requestMethod="requestMethod"
            scopeName="editForm"
            @before-save-data="beforeSaveData"
            @after-save-data="afterSaveData"
        >{{$t('eip.common.save')}}</fe-submit-button>
      </div>
    </eco-sidebar-dialog>

    <!-- 编辑面板 -->
    <eco-sidebar-dialog
    destroy-on-close
        width="28%"
        title="编辑岗位"
        :visible="editDialog"
        :before-close="handleClose"
        :append-to-body="true"
    >
      <el-form v-model="OrgPost"  :label-position="position" style="padding: 20px">
        <eco-form-item label="岗位名称" prop="code" label-width="100px">
          <eco-input
              v-model="OrgPost.name"
              autocomplete="off"
              :validate="{required:true}"
              placeholder="岗位名称"
          ></eco-input>
        </eco-form-item>
        <eco-form-item label="岗位编码" prop="code" label-width="100px">
          <eco-input
              v-model="OrgPost.code"
              :disabled="true"
          ></eco-input>
        </eco-form-item>

      </el-form>
      <div class="demo-drawer__footer">
        <el-button @click="handleClose()">{{$t('eip.common.cancel')}}</el-button>
        <fe-submit-button
            :url="saveOrgPost"
            :model="OrgPost"
            :isSubmit="isSubmit"
            :requestMethod="requestMethod"
            scopeName="editDemForm"

            @before-save-data="beforeSaveData"
            @after-save-data="afterSaveData"
        >{{$t('eip.common.save')}}</fe-submit-button>
      </div>
    </eco-sidebar-dialog>

    <distrubutive-user ref="distrubutiveUser"></distrubutive-user>
    <fe-load-data :url="loadDataUrl" context="uc" @after-load-data="afterLoadData"></fe-load-data>

    <eco-sidebar-dialog
    destroy-on-close
        width="40%"
        title="查看岗位详情"
        :visible="diaType==='showInfo'"
        :before-close="handleClose"
        :append-to-body="true"
    >
    <div style="padding: 20px;height: calc(100% - 40px)">
      <table class="form-table" cellspacing="0" cellpadding="0" border="0">
        <tbody>
        <tr>
          <th width="150px">岗位名称（编码）:</th>
          <td>
            {{OrgPost.name}}({{OrgPost.code}})
          </td>
        </tr>
        <tr>
          <th width="150px">所属职务（编码）:</th>
          <td>
            {{OrgPost.jobName}}({{OrgPost.jobCode}})
          </td>
        </tr>
        <tr>
          <th width="150px">所属组织（编码）:</th>
          <td>
            {{OrgPost.orgName}}({{OrgPost.orgCode}})
          </td>
        </tr>
        <tr>
          <th width="150px">岗位人员:</th>
          <td>
            <el-table :data="postUser" style="width: 100%" height="200" >
              <el-table-column prop="fullName" label="姓名" width="100"/>
              <el-table-column prop="pathName" label="人员所属组织全路径" />
            </el-table>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    </eco-sidebar-dialog>
  </div>
</template>
<script>
  // 组织岗位
  import org from "@/api/org.js";
  import uc from "@/api/uc.js";
  import EipUserDialog from "@/components/dialog/EipUserDialog.vue";
  import DistrubutiveUser from "./DistrubutiveUser";
  export default {
    name: "org-post",
    props:['orgId','orgCode'],
    components: {
      EipUserDialog,
      DistrubutiveUser
    },
    computed: {
      demDeleteUrl: function() {
        return window.context.uc + "/api/org/v1/orgPost/deleteOrgPost";
      },
      saveOrgPost: function() {
        let preUrl = window.context.uc + "/api/org/v1/orgPost";
        this.OrgPost.orgCode = this.orgCode;
        if (this.OrgPost.id) {
          preUrl += "/updateOrgPost";
        } else {
          preUrl += "/saveOrgPost";
        }
        return preUrl;
      },
      requestMethod: function() {
        return "POST";
      }
    },
    data() {
      return {
        position:"right",
        dialogVisible: false,
        dialogVisibleMenuPerm: false,
        OrgPost: {
          jobCode:"",   //职务编码
          jobName:"",    //职务名称
          name:"",   //岗位名称
          code:""    //岗位编码
        },
        job: [],
        isSubmit: true,
        data: [],
        pageResult: {
          page: 1,
          pageSize: 50,
          total: 0
        },
        loadDataUrl: "",
        menuPerm: {},
        allowRoles: [],
        readOnly: false,
        distOrgUser:false,   //分配岗位人员页面
        diaType:'',
        postUser:[],
        editDialog:false
      };
    },
    mounted() {
      this.$validator = this.$root.$validator;

    },
    methods: {
      setDemDefault(row){
        org.setDemDefault(row.code).then(() => {
          this.$refs.ecoTable.load();
        })
      },
      handleClose() {
        this.dialogVisible = false;
        this.diaType = false;
        this.editDialog = false;
      },
      handleCloseMenuPerm() {
        this.dialogVisibleMenuPerm = false;
      },
      showDialog(row) {
        this.readOnly = false;
        this.dialogVisible = true;
        uc.getJobPage({"pageBean":{"page":1,"pageSize":1000}}).then(resp => {
          this.job = resp.rows
        });
        if (row) {
          var _code = `${row.code}`;
          org.getOrgPost(_code).then(resp => {
            this.OrgPost = resp.value
          })
        } else {
          this.OrgPost = {name:"",code:"",jobName:"",jobCode: ""};
        }
      },
      dialogCancle(dialogVisible) {
        this[dialogVisible] = false;
      },
      loadData(param, cb) {
        uc.getOrgPostPage(param).then(rep => {
          this.data = rep.rows;
          this.pageResult = {
            page: rep.page,
            pageSize: rep.pageSize,
            total: rep.total
          };
        }).finally(() => cb());
      },
      handleCommand(params) {
        this.readOnly = false;
        switch (params.command) {
          case "showInfo":
            this.readOnly = true;
            this.$refs.distrubutiveUser.showDialog(params.row.id,params.row.code);
            break;
          case "orgInfo":
            this.diaType = 'showInfo';
            this.OrgPost = params.row;
            org.getFullname(params.row.id).then(resp => {
              this.postUser = resp;
            });
            break;
          case "setPostMaster":
            var isMain =false;
            if (params.row.isCharge==0){
              isMain =true;
            }
            org.setPostMaster({postCode:params.row.code,isMain:isMain}).then(() => {
              this.$refs.ecoTable.load();
            });
            break;
          case "edit":
            console.log(params.row);
             org.getOrgPost(params.row.code).then(resp => {
               this.OrgPost = resp.value;
             });
            this.editDialog = true;
            break;
          default:
            break;
        }
      },
      async beforeSaveData() {
        this.isSubmit = true;
      },
      afterSaveData() {
        this.dialogVisible = false;
        this.editDialog = false;
        this.$refs.ecoTable.load();
      },
      afterDelete() {
        this.$refs.ecoTable.load();
      },
      afterLoadData(data) {
        // 编辑角色
        if (this.dialogVisible) {
          this.demension = data;
          setTimeout(() => this.$validator.validateAll("editDemForm"));
        }
      },
      distOrgUserLoad(param, cb){
        org.getOrgUserPage(param)
          .then(response => {
            this.data = response.rows;
            this.pageResult = {
              page: response.page,
              pageSize: response.pageSize,
              total: response.total
            };
          })
          .finally(() => cb());
      }
    }
  };
</script>
<style scoped>
  div[aria-invalid="true"] >>> .el-input__inner,
  div[aria-invalid="true"] >>> .el-input__inner:focus {
    border-color: #f56c6c;
  }
</style>
